import { type PaymentConfig, type PropertyBankInfo } from '../../lib/api';

export type MethodSelection = 'ach' | 'external' | 'none';

/**
 * Derive the initial method selector state from config.
 * Priority order:
 *   1. Persisted methodIntent (user's explicit selection)
 *   2. Active paymentMethod (live/activated method)
 *   3. Configuration hints (destinationId set → ACH intent, zelleRecipientInfo / monitoring → external)
 */
export function deriveInitialMethodIntent(config: PaymentConfig | null, propertyBankInfo?: PropertyBankInfo | null): MethodSelection {
  if (!config) return 'none';
  // 1. Prefer the persisted intent if set
  if (config.methodIntent != null) {
    if (config.methodIntent === 'skipped') return 'none';
    return config.methodIntent;
  }
  // 2. If a method is active, use that
  if (config.paymentMethod !== 'none') return config.paymentMethod;
  // 3. Infer intent from configuration state
  const hasAchIntent = !!config.destinationId;
  const hasExternalIntent = !!config.zelleRecipientInfo || !!propertyBankInfo?.monitoringAccount;
  if (hasAchIntent) return 'ach';
  if (hasExternalIntent) return 'external';
  return 'none';
}
